<script setup lang="ts">
import { useRouter } from '#imports'

const router = useRouter()

export interface StrapiLinkToSectionProps {
    routeHash: string | null
}

const props = defineProps<StrapiLinkToSectionProps>()

function addHashToURL(): void {
    router.replace({ hash: `#${props.routeHash}` })
}
</script>

<template>
    <span
        v-if="routeHash"
        :id="routeHash"
        class="link-to-section"
        @click="addHashToURL"
    >
        <slot />
    </span>
    <slot v-else />
</template>

<style scoped lang="scss">
.link-to-section {
    cursor: pointer;
}
</style>
